"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WeatherOption_1 = require("owa-weather-option/lib/WeatherOption");
var AppearanceOption_1 = require("owa-calendar-appearance-option/lib/AppearanceOption");
var loadCalendarMailboxConfiguration_1 = require("./loadCalendarMailboxConfiguration");
var personalizationSubCategory = {
    key: 'personalization',
    titleStringKey: 'optionSubcategory_personalization',
    options: [AppearanceOption_1.default, WeatherOption_1.default],
    onSelected: loadCalendarMailboxConfiguration_1.default,
};
exports.default = personalizationSubCategory;
//# sourceMappingURL=personalizationSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-options-calendar/lib/data/personalizationSubCategory.js
// module id = 5245
// module chunks = 2